<template>
  <div>
    <v-card class="py-3 px-3 mb-5">
      <div>
        <h4 class="text-uppercase mb-3">
          {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.invoice') }}
        </h4>

        <template v-if="order && order.invoice">
          <button @click.prevent="getInvoicePdf(order.invoice.id, order.invoice.name)" class="invoice-download">
            {{ order.invoice.name }}
            <v-icon>$vuetify.icons.download</v-icon>
          </button>
        </template>
      </div>
    </v-card>
  </div>
</template>

<script>

import { EcoChallengeInvoiceApiService } from "@/common/services/eco-challenge-invoice.api.service";
import { downloadFile } from '@/common/helpers/downloads';

export default {
  props: {
    order: {
      type: Object,
      default: null,
    },
  },

  methods: {
    async getInvoicePdf(invoiceId, invoiceName) {
      try {
        const response = await EcoChallengeInvoiceApiService.get(this.order.id, invoiceId);

        const blob = response.getBody();

        const blobUrl = window.URL.createObjectURL(blob);

        downloadFile(blobUrl, invoiceName);

        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style>
.invoice-download {

}
</style>
